import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  InputGroup,
} from "react-bootstrap";
import "./Refer_and_Earn.css";
import { Referal } from "../../../utils/apis/myAccount/myAccount";

const Refer_and_Earn = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(data?.user?.refer_code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  //

  const [data, setdata] = useState({});
  const GetData = async () => {
    const res = await Referal();
    if (res?.success) {
      setdata(res.data);
    }
  };


  useEffect(() => {
    GetData();
  }, []);

  return (
    <section className="Refer_and_Earn ">
      <div className="refer-container">
        {/* Banner / Header */}
        <div className="refer-header">
          <h2>Refer & Earn</h2>
          <p>
            Invite your friends and earn <span>10% Cashback</span> on every
            referral!
          </p>
        </div>
        <div className="inner_section_box">
          {/* Referral Code Section */}
          <Row className="justify-content-center mt-4">
            <Col md={6}>
              <div className="refer-code-box">
                <Form.Label className="text-light">
                  Your Referral Code
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    value={data?.user?.refer_code || ""}
                    readOnly
                    className="referral-input"
                  />
                  <Button variant="outline-info" onClick={handleCopy}>
                    {copied ? "Copied!" : "Copy"}
                  </Button>
                  {/* <Button variant="info" className="share-btn">
                    Share
                  </Button> */}
                </InputGroup>
              </div>
            </Col>
          </Row>

          {/* Referral Table Section */}
          <div className="refer-table  mt-5">
            <div className="Transaction_History">
              <div className="table-responsive table_holder mt-0">
                <Table>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>User</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.refered_users?.map((val, index) => (
                      <tr key={index}>
                        <td>{++index}</td>
                        <td>
                          {val?.refer_user?.first_name}{" "}
                          {val?.refer_user?.last_name}
                        </td>
                        <td>$ {val?.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Refer_and_Earn;
